import {onLCP, onCLS} from 'web-vitals';
import ApplicationApiCall from "./functions/application-api-call";
import shopifyContext from "./context";

const reportWebVitals = data => {
  console.log('Start calculating CLS index...');
  console.log(data);
  /*if (data !== undefined && data.rating !== 'good') {
    console.log('LCP index is not good!');
    data.access_url = window.location.href;
    const shopify = shopifyContext.getShared();
    const configuration = shopify.getConfigurationSelected();
    const params = {configuration};
    ApplicationApiCall.post('/application/analytics', params, data, (json) => {
      console.log('Done');
    }, (err) => {
      console.log('Error');
    }, false);
  }*/
};

onCLS(reportWebVitals);
/*onFID(reportWebVitals);
onLCP(reportWebVitals);*/

export default reportWebVitals;
